import React, { useEffect, useState } from 'react';
import Loading from '../../loading/Loading';
import TableLayout, { TD, selectSx } from '../../ui/TableLayout';
import Apis from '../../Apis';
import axios from 'axios';
import { FiLock, FiUnlock } from 'react-icons/fi';

const COLS = ['Login', 'Email', 'Status', 'Ações'];
const headers = () => ({ 'Content-Type': 'application/json', Authorization: localStorage.getItem('token') });

const StatusBadge = ({ bloqueio }) => {
    const bloqueado = String(bloqueio) === '0';
    return (
        <span style={{
            display: 'inline-block', padding: '2px 12px', borderRadius: 40,
            background: bloqueado ? 'rgba(239,68,68,0.1)' : 'rgba(16,185,129,0.1)',
            color: bloqueado ? '#dc2626' : '#059669',
            fontSize: 11, fontWeight: 600,
        }}>
            {bloqueado ? 'Bloqueado' : 'Desbloqueado'}
        </span>
    );
};

export default function ListaUsuarios() {
    const [search, setSearch] = useState('');
    const [status, setStatus] = useState('-1');
    const [perPage, setPerPage] = useState(25);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [bloqueandoId, setBloqueandoId] = useState(null);

    const fetchData = (s = status, pp = perPage, q = search) => {
        setLoading(true);
        const params = new URLSearchParams({ pesquisa: q, status: s, qtd_registros: pp });
        axios.get(`${Apis.urlListarUsuarios}?${params.toString()}`, { headers: headers() })
            .then(res => setData(res.data.registros || []))
            .catch(() => setData([]))
            .finally(() => setLoading(false));
    };

    useEffect(() => { fetchData(); }, []); // eslint-disable-line

    const handlePerPage = (val) => { setPerPage(val); fetchData(status, val); };

    const handleBloqueio = (user) => {
        const bloqueio = String(user.bloqueio) === '0' ? 1 : 0;
        setBloqueandoId(user.id);
        axios.put(Apis.urlAlterarBloqueioUsuario, { id: user.id, bloqueio }, { headers: headers() })
            .then(() => setData(current => current.map(item => (
                item.id === user.id ? { ...item, bloqueio } : item
            ))))
            .catch(err => alert(err.response?.data?.retorno?.mensagem || 'Erro ao alterar o bloqueio do usuário.'))
            .finally(() => setBloqueandoId(null));
    };

    const Toolbar = (
        <select value={status} onChange={e => { const value = e.target.value; setStatus(value); fetchData(value); }} style={selectSx}>
            <option value="-1">Todos os status</option>
            <option value="1">Ativos</option>
            <option value="0">Inativos</option>
        </select>
    );

    if (loading) return <Loading />;

    return (
        <TableLayout
            title="Lista de Usuários"
            icon={null}
            count={data.length}
            columns={COLS}
            search={{ value: search, onChange: setSearch, placeholder: 'Buscar por login ou email…', onSubmit: () => fetchData() }}
            pagination={{ value: perPage, onChange: handlePerPage }}
            toolbar={Toolbar}
            emptyMessage="Nenhum usuário encontrado para os filtros aplicados."
        >
            {data.map((user, index) => (
                <tr key={user.id} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f8fafc' }}
                    onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#eff6ff')}
                    onMouseLeave={e => (e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#fff' : '#f8fafc')}
                >
                    <TD left>{user.login || user.nome || '—'}</TD>
                    <TD>{user.email || '—'}</TD>
                    <TD><StatusBadge bloqueio={user.bloqueio} /></TD>
                    <TD>
                        <button
                            type="button"
                            title={String(user.bloqueio) === '0' ? 'Desbloquear usuário' : 'Bloquear usuário'}
                            aria-label={String(user.bloqueio) === '0' ? 'Desbloquear usuário' : 'Bloquear usuário'}
                            disabled={bloqueandoId === user.id}
                            onClick={() => handleBloqueio(user)}
                            style={{
                                width: 30, height: 30, border: 'none', borderRadius: 6,
                                cursor: bloqueandoId === user.id ? 'wait' : 'pointer',
                                color: String(user.bloqueio) === '0' ? '#059669' : '#f59e0b',
                                background: String(user.bloqueio) === '0' ? 'rgba(16,185,129,0.08)' : 'rgba(245,158,11,0.1)',
                                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                opacity: bloqueandoId === user.id ? 0.55 : 1,
                            }}
                        >
                            {String(user.bloqueio) === '0' ? <FiUnlock size={14} /> : <FiLock size={14} />}
                        </button>
                    </TD>
                </tr>
            ))}
        </TableLayout>
    );
}